export default "__VITE_ASSET__BGhRsWUQ__"